import React from 'react';
import PropTypes from 'prop-types';
import { shouldUpdate } from 'recompose';

const PageHeader = ({ children }) => <section className="flex-page-header">{children}</section>;

const checkPropsChange = (props, nextProps) => props.children !== nextProps.children;

PageHeader.propTypes = {
  children: PropTypes.node.isRequired,
};

export default shouldUpdate(checkPropsChange)(PageHeader);
